// PITH FAQ accordion (progressive enhancement).
//
// The FAQ page body is authored in Admin > Content > Pages > "FAQ's" as a plain
// list: <ul><li><h4>Question</h4> …answer markup… </li></ul>. This script turns
// each <li> into a native <details> disclosure so the page reads as an
// accordion, with no change to how the content is edited. If the script fails to
// run the page still shows every question and answer as a normal list.
//
// Loaded by templates/page.faqs.json (custom-liquid block), scoped to the
// `.ds-faq` wrapper. Styles: assets/ds-sections.css ("FAQ ACCORDION").

(function () {
  const HEADING = 'h1, h2, h3, h4, h5, h6';

  function enhance(root) {
    if (root.dataset.faqEnhanced === 'true') return;
    root.dataset.faqEnhanced = 'true';

    root.querySelectorAll('ul, ol').forEach((list) => {
      const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
      if (items.length < 2) return;

      // Only treat a list as FAQ items when every row leads with a heading.
      const isFaqList = items.every((li) => {
        const first = li.querySelector(':scope > *');
        return first && first.matches(HEADING);
      });
      if (!isFaqList) return;

      const wrap = document.createElement('div');
      wrap.className = 'ds-faq__list';

      items.forEach((li) => {
        const heading = li.querySelector(':scope > ' + HEADING);
        const question = heading.textContent.trim();
        heading.remove();

        const details = document.createElement('details');
        details.className = 'ds-faq__item';

        const summary = document.createElement('summary');
        summary.className = 'ds-faq__q';
        const qText = document.createElement('span');
        qText.className = 'ds-faq__q-text';
        qText.textContent = question;
        const icon = document.createElement('span');
        icon.className = 'ds-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.append(qText, icon);

        const answer = document.createElement('div');
        answer.className = 'ds-faq__a rte';
        while (li.firstChild) answer.appendChild(li.firstChild);

        details.append(summary, answer);
        wrap.appendChild(details);
      });

      list.replaceWith(wrap);
    });
  }

  function init() {
    document.querySelectorAll('.ds-faq').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
